export const SSN_PATTERN = /^\d{3}-\d{2}-\d{4}$/;
export const ITIN_PATTERN = /^9\d{2}-\d{2}-\d{4}$/;
export const EIN_PATTERN = /^\d{2}-\d{7}$/;
